import { Box, Button, Card, WixDesignSystemProvider, MarketingPageLayout, MarketingPageLayoutContent, Page, Loader } from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import React, { useEffect } from "react";
import * as Icons from "@wix/wix-ui-icons-common";
import { ReactTagManager } from "react-gtm-ts";
import { useTranslation } from "react-i18next";
import { initAnalytics, track } from "./analytics";

const tagManagerArgs = { code: "GTM-WZQPMC7" };
const BASE_URL = "https://wix.certifiedcode.io/image-zoom/_functions";
const WIX_APP_ID = "0946b565-211d-411d-8b72-71cf19908103";

function App() {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  const instance = new URLSearchParams(window.location.search).get("instance");
  const [isUpgraded, setIsUpgraded] = React.useState(false);
  const [instanceData, setInstanceData] = React.useState({ instance: { isFree: true, availablePlans: [], instanceId: "" } } as any);

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
    initAnalytics();
    loadInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function loadInstance() {
    fetch(BASE_URL + "/@certifiedcode/base-backend/instance", {
      method: "GET",
      headers: { Authorization: instance || "" },
    })
      .then((response) => response.json())
      .then((data) => {
        setInstanceData(data);
        setIsUpgraded(data?.instance?.isFree === false);
      })
      .catch(() => {});
  }

  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;

  if (token) {
    window.location.href = `https://www.wix.com/installer/install?token=${token}&appId=${WIX_APP_ID}&redirectUrl=https://wix.certifiedcode.io/image-zoom/_functions/@certifiedcode/base-backend/auth`;
    return (
      <WixDesignSystemProvider features={{ newColorsBranding: true }}>
        <Page height="100vh"><Page.Content>
          <Box height={"90vh"} direction="vertical" verticalAlign="middle"><Loader text={t("loading")} /></Box>
        </Page.Content></Page>
      </WixDesignSystemProvider>
    );
  }

  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <Card>
        <MarketingPageLayout removeImageHorizontalPadding removeImageVerticalPadding
          content={
            <Box height="840px" verticalAlign="middle">
              <MarketingPageLayoutContent
                title={t("iz-title")}
                content={t("iz-content")}
                actions={
                  <Box gap="SP2">
                    <Button suffixIcon={<Icons.Edit />} as="a" href={`https://www.wix.com/editor/${instanceData?.site?.siteId}`} target="_blank">{t("iz-edit-button")}</Button>
                    <Button suffixIcon={<Icons.PremiumFilled />} skin={isUpgraded ? "premium-light" : "premium"} as="a" href={upgradeUrl} target="_blank" onClick={() => track("upgrade_clicked")}>{isUpgraded ? t("manage-plan") : t("upgrade")}</Button>
                  </Box>
                }
              />
            </Box>
          }
        />
      </Card>
    </WixDesignSystemProvider>
  );
}

export default App;
